import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Card, Result } from "antd";
import SettingsPageLayout from "../SettingsPageLayout";
import { SUBSCRIPTION_OUTER_CARD_CLASS, subscriptionCardTitle } from "./billingLayoutClasses";

// Shown instead of the subscription checkout while the platform runs in FREE mode.
const FreePlanCard = () => {
    const { t } = useTranslation("settings");
    const history = useHistory();

    return (
        <SettingsPageLayout
            title={t("billing.title")}
            description={t("billing.freePlan.description", "SoftCar is currently free for everyone.")}>
            <Card
                className={SUBSCRIPTION_OUTER_CARD_CLASS}
                title={subscriptionCardTitle(t("billing.freePlan.title", "You're on the Free plan"))}>
                <Result
                    status="success"
                    title={t("currentlyOnFreePlan")}
                    subTitle={t(
                        "billing.freePlan.details",
                        "All features and unlimited vehicles are included. No payment required.",
                    )}
                    extra={
                        <Button type="primary" shape="round" onClick={() => history.push("/")}>
                            {t("billing.freePlan.continue", "Go to dashboard")}
                        </Button>
                    }
                />
            </Card>
        </SettingsPageLayout>
    );
};

export default FreePlanCard;
